import { genreOptions, regionOptions, yearOptions } from '@/mocks/resources';

interface FilterPanelProps {
  regionSelected: string[];
  yearSelected: number[];
  genreSelected: number[];
  onToggleRegion: (value: string) => void;
  onToggleYear: (value: number) => void;
  onToggleGenre: (value: string) => void;
  onReset: () => void;
}

export default function FilterPanel({
  regionSelected,
  yearSelected,
  genreSelected,
  onToggleRegion,
  onToggleYear,
  onToggleGenre,
  onReset,
}: FilterPanelProps) {
  const activeCount =
    regionSelected.length + yearSelected.length + genreSelected.length;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-filter-3-line text-primary-600" />
          筛选条件
        </h3>
        {activeCount > 0 && (
          <button
            type="button"
            onClick={onReset}
            className="cursor-pointer text-xs font-label text-primary-600 transition-colors hover:text-primary-700"
          >
            重置（{activeCount}）
          </button>
        )}
      </div>

      <div className="flex flex-col gap-5">
        <FilterGroup
          title="地区"
          options={regionOptions}
          selected={regionSelected}
          onToggle={onToggleRegion}
        />
        <FilterGroup
          title="年份"
          options={yearOptions}
          selected={yearSelected}
          onToggle={onToggleYear}
          suffix="年"
        />
        <FilterGroup
          title="类型"
          options={genreOptions}
          selected={genreSelected}
          onToggle={onToggleGenre}
        />
      </div>
    </div>
  );
}

interface FilterGroupProps {
  title: string;
  options: (string | number)[];
  selected: (string | number)[];
  onToggle: (value: any) => void;
  suffix?: string;
}

function FilterGroup({ title, options, selected, onToggle, suffix = '' }: FilterGroupProps) {
  return (
    <div>
      <h4 className="mb-2.5 text-sm font-medium font-label text-foreground-700">
        {title}
      </h4>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = selected.includes(option);
          return (
            <button
              key={option}
              type="button"
              onClick={() => onToggle(option)}
              className={`cursor-pointer rounded-md border px-3 py-1.5 text-xs font-label transition-colors ${
                active
                  ? 'border-primary-500 bg-primary-500 text-background-50'
                  : 'border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
              }`}
            >
              {option}
              {suffix}
            </button>
          );
        })}
      </div>
    </div>
  );
}